import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { LocationCity } from "@mui/icons-material";
import { ReactComponent as StopIcon } from "../../features/FloorManager/assets/no-stopping.svg";
import MWImage from "../../features/Booking-Form/assets/mobile-working.jpeg";
import { StyledLogoImg } from "../Menu/ResponsiveDrawer/StyledLogoComp.partial";
import {
  topListHeroImageSx,
  topListHeroMediaSx,
  topListHeroOverlaySx
} from "../../features/Dashboard/dashboard.styles";

type P = {
  locationName: string;
  picturePath?: string;
};

const topListFallbackIconSx = { width: 48, height: 48 } as const;

export const TopListLocationMedia: React.FC<P> = ({ locationName, picturePath }) => {
  const [loaded, setLoaded] = useState(false);
  const [imageFailed, setImageFailed] = useState(false);
  const normalizedPicturePath = picturePath?.trim();

  useEffect(() => {
    setImageFailed(false);
    setLoaded(false);
  }, [normalizedPicturePath, locationName]);

  if (normalizedPicturePath && !imageFailed) {
    return (
      <Box data-testid="top-list-location-hero" sx={topListHeroMediaSx}>
        <StyledLogoImg
          src={normalizedPicturePath}
          alt={locationName}
          fadein={loaded}
          sx={topListHeroImageSx}
          onLoad={() => setLoaded(true)}
          onError={() => {
            setImageFailed(true);
            setLoaded(true);
          }}
        />
        <Box sx={topListHeroOverlaySx} aria-hidden />
      </Box>
    );
  }

  if (locationName === "Mobile Working") {
    return (
      <Box
        data-testid="top-list-location-media"
        data-variant="mobile-working"
        sx={{
          ...topListHeroMediaSx,
          backgroundImage: `url(${MWImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center"
        }}
      >
        <Box sx={topListHeroOverlaySx} aria-hidden />
      </Box>
    );
  }

  if (locationName === "No Booking Time") {
    return (
      <Box
        data-testid="top-list-location-media"
        data-variant="no-booking-time"
        sx={{
          ...topListHeroMediaSx,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "action.selected"
        }}
      >
        <StopIcon style={topListFallbackIconSx} />
      </Box>
    );
  }

  return (
    <Box
      data-testid="top-list-location-media"
      data-variant="fallback"
      sx={{
        ...topListHeroMediaSx,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "action.hover"
      }}
    >
      <LocationCity sx={{ ...topListFallbackIconSx, color: "text.secondary" }} />
    </Box>
  );
};
